"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
var HttpService = /** @class */ (function () {
    function HttpService() {
    }
    HttpService.prototype._authenticateRequest = function (xhr, token) {
        if (token) {
            xhr.setRequestHeader('Authorization', "Bearer ".concat(token));
        }
    };
    HttpService.prototype._handleJSONResponse = function (xhr) {
        return JSON.parse(xhr.responseText);
    };
    HttpService.prototype.get = function (url, authToken, withCredentials) {
        var _this = this;
        if (withCredentials === void 0) { withCredentials = false; }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.withCredentials = withCredentials;
            _this._authenticateRequest(xhr, authToken);
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        resolve(_this._handleJSONResponse(xhr));
                    }
                    catch (error) {
                        reject({
                            status: xhr.status,
                            statusText: xhr.statusText,
                            error: error.message
                        });
                    }
                }
                else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send();
        });
    };
    return HttpService;
}());
exports.HttpService = HttpService;
